export default "__VITE_ASSET__DomwHxZT__"